import {
  ExclamationTriangleIcon,
  InformationCircleIcon,
  XCircleIcon,
} from "@heroicons/react/20/solid"
import { cn } from "@src/utils/cn"
import type { ReactNode } from "react"
import ErrorMessage from "./ErrorMessage"

const Alert = ({
  variant,
  className,
  children,
}: {
  variant: "error" | "info" | "warning"
  className?: string
  children: ReactNode
}) => {
  const baseClasses = "pl-3 pr-6 py-3 rounded-2xl flex items-start gap-3"

  if (variant === "error") {
    return (
      <div
        className={cn(
          "dark:-outline-offset-1 bg-red-50 dark:bg-red-500/10 dark:outline dark:outline-red-500/10",
          baseClasses,
          className
        )}
      >
        <XCircleIcon
          className="size-5 shrink-0 text-red-600 dark:text-red-400"
          aria-hidden
        />
        <ErrorMessage>{children}</ErrorMessage>
      </div>
    )
  }

  if (variant === "warning") {
    return (
      <div
        className={cn(
          "-outline-offset-1 bg-yellow-50 outline outline-yellow-100 dark:bg-yellow-500/10 dark:outline-yellow-500/10",
          baseClasses,
          className
        )}
      >
        <ExclamationTriangleIcon
          className="mt-px size-5 shrink-0 text-yellow-500 dark:text-yellow-300"
          aria-hidden
        />
        <div className="font-semibold text-sm/5 text-yellow-800 dark:text-yellow-100">
          {children}
        </div>
      </div>
    )
  }

  if (variant === "info") {
    return (
      <div
        className={cn(
          "dark:-outline-offset-1 bg-blue-50 dark:bg-blue-500/10 dark:outline dark:outline-blue-500/10",
          baseClasses,
          className
        )}
      >
        <InformationCircleIcon
          className="size-5 shrink-0 text-blue-400"
          aria-hidden
        />
        <div className="font-semibold text-blue-700 text-sm/5 dark:text-blue-300">
          {children}
        </div>
      </div>
    )
  }

  return null
}

export default Alert
